<template>
<div class="chapter">
<div class="inner_page">
<p class="C136"><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="C137"><a id="page_vii"><em></em></a><em><a href="#/xhtml/05_Acknowle#page_ix">Acknowledgments</a></em></p>
<p class="C138"><em><a href="#/xhtml/06_Introduc#page_1">Introduction: The Mission of Display</a></em></p>
<p class="C139"><a href="#/xhtml/07_1___A_Vi#page_8">1. “A Vision of the Future”: The New Museum Idea and Display Reform, 1890–1915</a></p>
<p class="C138"><span href="#/xhtml/08_2__The_D#page_51" title="Link target outside of Sample">2. The Drama of the Diorama, 1910–1935</span></p>
<p class="C138"><span href="#/xhtml/09_3__Displ#page_91" title="Link target outside of Sample">3. Displays in Motion: Experimentation and Stagnation in Exhibition, 1925–1940</span></p>
<p class="C138"><span href="#/xhtml/10_4__Diver#page_136" title="Link target outside of Sample">4. Diversifying Displays, Diverging Museums: Postwar Life Science Education, 1941–1956</span></p>
<p class="C138"><span href="#/xhtml/11_5___An_I#page_175" title="Link target outside of Sample">5. “An Investment in the Future of America”: Competing Pedagogies in Post-Sputnik Museums, 1957–1969</span></p>
<p class="C138"><span href="#/xhtml/12_6__The_E#page_208" title="Link target outside of Sample">6. The Exploratorium Effect: Redefining Relevance and Interactive Display, 1969–1980</span></p>
<p class="C138"><span href="#/xhtml/13_7__From#page_247" title="Link target outside of Sample">7. From Diversity to Standardization: Edutainment and Engagement in Museums at the End of the Century, 1976–2005</span></p>
<p class="C139"><em><span href="#/xhtml/14_Notes#page_283" title="Link target outside of Sample">Notes</span></em></p>
<p class="C138"><em><span href="#/xhtml/15_Bibliogr#page_395" title="Link target outside of Sample">Bibliographic Essay on Sources</span></em></p>
<p class="C138"><em><span href="#/xhtml/16_Bibliogr#page_409" title="Link target outside of Sample">Bibliography</span></em></p>
<p class="C138"><em><span href="#/xhtml/17_Index#page_449" title="Link target outside of Sample">Index</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?27fa9cdf